module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAU9JREFUOBGl0z9LQlEYx3Fvf5zEqZYgB0GhuNAQvYPu0NLmGDQ4CL4ArRfQ7GAO0dAmBA5ugdSkY4NDBDUlNDQEloMtef3+Ttfu4UZi9sDn3vPvec65cozFIuH7vosK7jAIqK0xN7I87DIZRxWf+C00pzXxMJOWBnCNWUNrwyJ0TmfNtNZVzSkY0DdPO7Zyaiigo04QynGXqJLHgqkWPl5pVpBACXtYxQWWsQPl5FXAgx33dDzHcZ7ZQUmL6GEd+2hABRSeCqRM8+sx4KXdRiQf8k6iSbE2/Vva2v0Jk0hFj37GzAau8IYP3JBc5r2LFRTxHSqg401CJzjAOTLQcR+RRR9D2NFTgZY1oh+0jm284Bja4AgnSMOOlsPxdD27UDHFOy7xAH3GGnLYhB0jOltmgCLzXyRVoMD/rrJVRCeZdis19/PPZL4jeLDgT3/nMXKj4Fgxny34AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/WB.png
// module id = myXD
// module chunks = 1